//form2
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Modal from "react-bootstrap/Modal"; // Bootstrap modal
import Button from "react-bootstrap/Button";

export default function DetailForm({
  nextStep,
  prevStep,
  formData,
  updateState,
}) {
  const [formFields, setFormFields] = useState(formData);
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [showPrevModal, setShowPrevModal] = useState(false);

  useEffect(() => {
    setFormFields((prevFields) => ({
      ...prevFields,
      ...formData,
    }));
  }, [formData]);

  const handleInputChange = (field) => (e) => {
    const value = e.target.value;
    const updatedFields = {
      ...formFields,
      [field]: value,
    };
    setFormFields(updatedFields);
    updateState(updatedFields);
  };

  

  const validateFields = () => {
    const newErrors = {};

    [1, 2, 3].forEach((i) => {
      if (i === 1) {
        if (!formFields[`name_of_business_${i}`]) {
          newErrors[`name_of_business_${i}`] = `Business name ${i} is required`;
        }
        if (!formFields[`annual_turnover_${i}`]) {
          newErrors[`annual_turnover_${i}`] = `Annual turnover ${i} is required`;
        }
        if (!formFields[`nature_of_business_${i}`]) {
          newErrors[`nature_of_business_${i}`] = `Nature of business ${i} is required`;
        }
      } else {
        // If any optional group (2 or 3) has *any* one field filled, validate all
        const businessName = formFields[`name_of_business_${i}`];
        const turnover = formFields[`annual_turnover_${i}`];
        const nature = formFields[`nature_of_business_${i}`];
    
        const isAnyFieldFilled = businessName || turnover || nature;
    
        if (isAnyFieldFilled) {
          if (!businessName) {
            newErrors[`name_of_business_${i}`] = `Business name ${i} is required if other fields are filled`;
          }
          if (!turnover) {
            newErrors[`annual_turnover_${i}`] = `Annual turnover ${i} is required if other fields are filled`;
          }
          if (!nature) {
            newErrors[`nature_of_business_${i}`] = `Nature of business ${i} is required if other fields are filled`;
          }
        }
      }
    });
    

     // Registered Firm
     if (!formFields["registered_firms_check"]) {
      newErrors["registered_firms_check"] = "Please select if you have a registered firm";
    } else if (formFields["registered_firms_check"] === "yes" && !formFields["registered_firms_details"]) {
      newErrors["registered_firms_details"] = "Please enter the registered firm details";
    }

    // Land Type
    if (!formFields["land_type"]) {
      newErrors["land_type"] = "Land type is required";
    }
    // if (!formFields["land_type"]) {
    //   newErrors["land_type"] = "Land type is required";
    // }
    // if (!formFields["activity_to_proposed_school"]) {
    //   newErrors["activity_to_proposed_school"] =
    //     "Involvement details are required";
    // }

    // if (!formFields["project_location"]) {
    //   newErrors["project_location"] =
    //     "Location/Cities Identified for the project are required";
    // }
    // if (!formFields["deatils_of_land_possession"]) {
    //   newErrors["deatils_of_land_possession"] =
    //     "Details of the land in your possession are required";
    // }
    // if (!formFields["school_academic_year"]) {
    //   newErrors["school_academic_year"] =
    //     "By when do you foresee the school academic session (year) are required";
    // }

    // if (!formFields['additional_plans']) {
    //   newErrors['additional_plans'] = 'Additional plans for school development are required';
    // }
    // if (!formFields['marketing_strategy']) {
    //   newErrors['marketing_strategy'] = 'Proposed marketing strategy for the school are required';
    // }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  // const handleNext = () => {
  //   if (validateFields()) {
  //     if (typeof nextStep === 'function') {
  //       nextStep(formFields);
  //     } else {
  //       console.error('nextStep is not a function');
  //     }
  //   }
  // };

  const handleNext = () => {
    if (validateFields()) {
      setShowModal(true); // ✅ Show modal after successful validation
    }
  };



  const handlePrevConfirm = () => {
    setShowPrevModal(false);
    if (typeof prevStep === "function") {
      prevStep();
    }
  };

  const handlePrevious = () => {
    setShowPrevModal(true);
  };

  const handleModalConfirm = () => {
    setShowModal(false);
    if (typeof nextStep === "function") {
      nextStep(formFields); // ✅ Corrected from 'onNext' to 'nextStep'
    }
  };

 
  return (
    <div className="container-fluid">
      <div className="row d-flex justify-content-center">
        <div className="col-lg-12">
          <div id="msform">
            <fieldset>
              <h2 className="fs-title">4. Nature of Business</h2>
              <table className="table">
                <thead>
                  <tr>
                    <th className="fs-title" scope="col">
                    
                     Name of Business   <span className="required-asterisk">*</span>
                    </th>
                    <th className="fs-title" scope="col">
                      Annual Turnover <span className="required-asterisk">*</span> 
                    </th>
                    <th className="fs-title" scope="col">
                      Nature of Business / Trade <span className="required-asterisk">*</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3].map((i) => (
                    <tr key={i}>
                      <td>
                        <input
                          type="text"
                          value={formFields[`name_of_business_${i}`] || ""}
                          name="Name"
                          onChange={handleInputChange(`name_of_business_${i}`)}
                          required
                          placeholder={`Enter business name ${i}`}
                          className="form-control inp"
                        />
                        {errors[`name_of_business_${i}`] && (
                          <p className="error-message">
                            {errors[`name_of_business_${i}`]}
                          </p>
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          value={formFields[`annual_turnover_${i}`] || ""}
                          onChange={handleInputChange(`annual_turnover_${i}`)}
                          required
                          placeholder={`Enter annual turnover ${i}`}
                          className="form-control inp"
                        />
                        {errors[`annual_turnover_${i}`] && (
                          <p className="error-message">
                            {errors[`annual_turnover_${i}`]}
                          </p>
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          value={formFields[`nature_of_business_${i}`] || ""}
                          onChange={handleInputChange(
                            `nature_of_business_${i}`
                          )}
                          required
                          placeholder={`Nature of Business / Trade ${i}`}
                          className="form-control inp"
                        />
                        {errors[`nature_of_business_${i}`] && (
                          <p className="error-message">
                            {errors[`nature_of_business_${i}`]}
                          </p>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Registered/Trust Section */}
              <div className="row">
                <div className="col-6">
                  <label className="left-text">
                    Do you have any Registered/Trust/Under Section 8 Company? If
                    yes, mention the name and details and profession of members
                  </label>
                </div>

                <div className="col-6">
                  <div className="radio1">
                    <input
                      type="radio"
                      name="registered_firms_check"
                      value="yes"
                      checked={formFields["registered_firms_check"] === "yes"}
                      onChange={handleInputChange("registered_firms_check")}
                    />
                    <label>Yes</label>
                  </div>
                  <div className="radio2">
                    <input
                      type="radio"
                      name="registered_firms_check"
                      value="no"
                      checked={formFields["registered_firms_check"] === "no"}
                      onChange={handleInputChange("registered_firms_check")}
                    />
                    <label>No</label>
                  </div>
                  {errors["registered_firms_check"] && <p className="error-message">{errors["registered_firms_check"]}</p>}
                  {formFields["registered_firms_check"] === "yes" && (
                    <div className="mt-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter details of the registered firm"
                        value={formFields["registered_firms_details"] || ""}
                        onChange={handleInputChange("registered_firms_details")}
                      />
                      {errors["registered_firms_details"] && <p className="error-message">{errors["registered_firms_details"]}</p>}
                    </div>
                  )}
                  
                  {/* {formFields["registered_firms_check"] === "yes" && (
                    <input
                      type="text"
                      value={formFields["registered_firms_details"] || ""}
                      onChange={handleInputChange("registered_firms_details")}
                      required
                      placeholder="Enter details of the registered firm"
                      className="form-control"
                    />
                  )} */}
                 
                </div>
              </div>
              

              {/* File Upload and Tax Return Section */}
              <div className="row">
                <div className="col-4">
                  <label className="left-text">
                    Land Type
                    <select
                      className="landtype"
                      value={formFields["land_type"] || ""}
                      onChange={handleInputChange("land_type")}
                    >
                      <option value="">Select Land Type</option>
                      <option value="Green Field">Green Field</option>
                      <option value="BrownFiled Project">BrownFiled Project</option>
                      <option value="Existing School Owners">Existing School Owners</option>
                    </select>
                    {errors["land_type"] && <p className="error-message">{errors["land_type"]}</p>}
                  </label>
                </div>

                <div className="col-4">
                <label className="left-text">
                Involvement Details
                  <textarea
                    className="mytextarea"
                    value={formFields["activity_to_proposed_school"] || ""}
                    onChange={handleInputChange("activity_to_proposed_school")}
                    required
                    placeholder="Involvement Details:"
                  />
                  </label>
                  {errors["activity_to_proposed_school"] && (
                    <p className="error-message">
                      {errors["activity_to_proposed_school"]}
                    </p>
                  )}
                </div>

                <div className="col-4">
                <label className="left-text">
                Involvement Details
                  <textarea
                    className="mytextarea"
                    value={formFields["project_location"] || ""}
                    onChange={handleInputChange("project_location")}
                    required
                    placeholder="Location/Cities Identified for the project"
                  />
                  </label>
                  {/* {errors["project_location"] && (
                    <p className="error-message">
                      {errors["project_location"]}
                    </p>
                  )} */}
                </div>
                </div>

                <div className="row">
                  <div className="col-4">
                  <label className="left-text">
                  Details of the land in your possession
                    <textarea
                      className="mytextarea"
                      value={formFields["deatils_of_land_possession"] || ""}
                      onChange={handleInputChange("deatils_of_land_possession")}
                      required
                      placeholder="Details of the land in your possession, including area of the land with address"
                    />
                    </label>

                    {errors["deatils_of_land_possession"] && (
                      <p className="error-message">
                        {errors["deatils_of_land_possession"]}
                      </p>
                    )}
                  </div>
                  <div className="col-4">
                  <label className="left-text">
                  By when do you foresee the school academic session (year)
                    <input
                      className="inp"
                      type="text"
                      value={formFields["school_academic_year"] || ""}
                      onChange={handleInputChange("school_academic_year")}
                      required
                      placeholder="By when do you foresee the school academic session (year)"
                    />
                    </label>
                    {errors["school_academic_year"] && (
                      <p className="error-message">
                        {errors["school_academic_year"]}
                      </p>
                    )}
                  </div>
                  <div className="col-4">
                    <label className="left-text">
                      Source of funds for starting & running the school
                      Operations
                    
                    <select
                      className="landtype"
                      value={formFields["fund_type"] || ""}
                      onChange={handleInputChange("fund_type")}
                    >
                      <option value="">Select Fund Type</option>
                      <option value="self_fund">Self Fund</option>
                      <option value="invester_fund">Investor Fund</option>
                      <option value="bank_loan">Bank Loan</option>
                    </select>
                    </label>
                   
                  </div>
                  </div>
                  
                {/* Additional Sections */}
                <div className="row">
                <div className="col-4">
                <label className="left-text">Any other information    
                <textarea
                    className="mytextarea"
                    value={formFields["additional_information"] || ""}
                    onChange={handleInputChange("additional_information")}
                    //required
                    placeholder="Any other information"
                  />
                 </label>
                 </div>
                  <div className="col-4">
                    <label className="left-text">
                      Additional plans for school development
                    <textarea
                      className="mytextarea"
                      value={formFields["additional_plans"] || ""}
                      onChange={handleInputChange("additional_plans")}
                      required
                      placeholder="Additional plans for school development"
                    />
                     </label>
                    {/* {errors['additional_plans'] && (
                    <p className="error-message">{errors['additional_plans']}</p>
                  )} */}
                  </div>
                  <div className="col-4">
                    <label className="left-text">
                      Proposed marketing strategy for the school
                    <textarea
                      className="mytextarea"
                      value={formFields["marketing_strategy"] || ""}
                      onChange={handleInputChange("marketing_strategy")}
                      required
                      placeholder="Proposed marketing strategy for the school"
                    />
                     </label>
                    {/* {errors['marketing_strategy'] && (
                    <p className="error-message">{errors['marketing_strategy']}</p>
                  )} */}
                  </div>
                </div>
             

              {/* Add other fields similar to UserForm */}
              <button
                className="previous action-button-previous"
                type="button"
                onClick={handlePrevious}
              >
                Previous
              </button>
              <button
                className="next action-button"
                type="button"
                onClick={handleNext}
              >
                Next
              </button>
            </fieldset>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header>
          {/* <Modal.Title>Confirm </Modal.Title> */}

          <Modal.Title className="mb-0">Confirm Submission</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body>
          All fields have been filled. Do you want to proceed to the next step
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            style={{
              border: "none",
              background: "#eabb1b",
              borderRadius: "25px",
              marginRight: "10px",
              padding: "10px 20px",
              fontWeight: "bold",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleModalConfirm}
            style={{
              borderRadius: "25px",
              background: "#174d82",
              padding: "10px 17px",
              fontWeight: "bold",
            }}
          >
            Yes, Continue
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPrevModal}
        onHide={() => setShowPrevModal(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title className="mb-0">Go Back Confirmation</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowPrevModal(false)}
          ></button>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to go back to the previous step?
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            onClick={() => setShowPrevModal(false)}
            style={{
              border: "none",
              background: "#eabb1b",
              borderRadius: "25px",
              marginRight: "10px",
              padding: "10px 20px",
              fontWeight: "bold",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handlePrevConfirm}
            style={{
              borderRadius: "25px",
              background: "#174d82",
              padding: "10px 17px",
              fontWeight: "bold",
            }}
          >
            Yes, Go Back
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

DetailForm.propTypes = {
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  updateState: PropTypes.func.isRequired,
};
